import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule as AngularFormsModule, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ChartsModule} from 'ng2-charts';

import {StatisticComponent} from './statistic.component';
import {StatisticService} from './statistic.service';
import {ListComponent} from './list/list.component';
import {routing} from './statistic.routing';

@NgModule({
  imports: [
    CommonModule,
    routing,
    FormsModule,
    ReactiveFormsModule,
    AngularFormsModule,
    ChartsModule
  ],
  declarations: [StatisticComponent, ListComponent],
  providers: [
  	StatisticService,
  ]
})
export class StatisticModule { }



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/statistic/statistic.module.ts